import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { IoTDevListStyle } from './IoTDevListStyle';
import {
  GetIoTBoxDeviceLists,
  IoTBoxDeviceLists,
  SetInstructManualCollection,
  V_IOTBOX_DEV_LIST,
  SetStudyCollection,
} from './IoTDevList';

import IotDevListHealthyErrorListDialog from './IotDevListHealthyErrorListDialog';

type IoTDevListHealthyButtonProps = {
  iotBoxData: V_IOTBOX_DEV_LIST;
};

/**
 * ボタンの色と文字の色の設定
 * @param kind
 * @returns
 */
const getButtonColor = (kind: number | undefined): string => {
  if (kind == undefined) return 'gray';

  switch (kind) {
    case 0: //正常
      return 'green';
    case 1: //軽故障
      return '#E4C068';
    case 2: //重故障
      return 'red';
    case 3: //システム異常
      return 'red';
    case -1: //未応答
      return 'gray';
    default:
      //不明
      return 'gray';
  }
};

const IoTDevListHealthyButton: React.FC<IoTDevListHealthyButtonProps> = (props) => {
  const pageStyle = IoTDevListStyle();
  const { t } = useTranslation();
  const [openErrorList, setOpenErrorList] = useState<boolean>(false);

  /**
   * ヘルシーチェック状態
   * @param sate
   * @returns
   */
  const getButtonText = (kind: number | undefined): string => {
    if (kind == undefined) return t('IoTDevListGrid.不明', '不明');
    switch (kind) {
      case 0:
        return t('IoTDevListGrid.正常', '正常');
      case 1:
        return t('IoTDevListGrid.軽故障', '軽故障');
      case 2:
        return t('IoTDevListGrid.重故障', '重故障');
      case 3:
        return t('IoTDevListGrid.システム異常', 'システム異常');
      case -1:
        return t('IoTDevListGrid.未応答', '未応答');
      default:
        return t('IoTDevListGrid.不明', '不明');
    }
  };
  /**
   * エラーログ日時選択ダイアログOPEN
   */
  const errorListDialogOpenAction = () => {
    setOpenErrorList(true);
  };

  /**
   * エラーログ日時選択閉じる
   */
  const errorListDialogCloseAction = () => {
    setOpenErrorList(false);
  };

  return (
    <>
      {(props.iotBoxData.IOT_SET.ALM_KIND ?? 0) == 0 ? (
        <div
          style={{
            background: getButtonColor(props.iotBoxData.IOT_SET.ALM_KIND),
            color: 'white',
            padding: '5px',
          }}
        >
          {getButtonText(props.iotBoxData.IOT_SET.ALM_KIND)}
        </div>
      ) : (
        <Button
          disabled={props.iotBoxData.IOT_SET.ALM_KIND == -1 ? true : false}
          className={pageStyle.buttonStyle}
          style={{
            borderColor: getButtonColor(props.iotBoxData.IOT_SET.ALM_KIND),
            color: getButtonColor(props.iotBoxData.IOT_SET.ALM_KIND),
            width: '130px',
          }}
          variant="outlined"
          onClick={(e) => errorListDialogOpenAction()}
        >
          {getButtonText(props.iotBoxData.IOT_SET.ALM_KIND)}
        </Button>
      )}

      <IotDevListHealthyErrorListDialog
        open={openErrorList}
        onClose={errorListDialogCloseAction}
        iotBoxData={props.iotBoxData}
      ></IotDevListHealthyErrorListDialog>
    </>
  );
};

export default IoTDevListHealthyButton;
